// Classifie une saisie utilisateur libre (recherche Dashboard / import CRM) :
// SIREN, SIRET, URL, ou invalide.
export function classifyProspectQuery(input) {
  const trimmed = (input ?? '').trim()
  if (!trimmed) return { kind: 'invalid' }

  // Test numérique : on tolère espaces et points (ex. "917 659 237" ou "917.659.237")
  const digitsOnly = trimmed.replace(/[\s.]/g, '')
  if (/^\d{9}$/.test(digitsOnly)) return { kind: 'siren', value: digitsOnly }
  if (/^\d{14}$/.test(digitsOnly)) return { kind: 'siret', value: digitsOnly }

  // URL absolue http/https
  try {
    const url = new URL(trimmed)
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return { kind: 'url', value: trimmed }
    }
  } catch {
    // Pas une URL absolue valide, on continue les autres heuristiques
  }

  // Tolérance : domaine sans schéma (ex. "pappers.fr/entreprise/..." ou "www.societe.com/...")
  const looksLikeBareDomain =
    trimmed.startsWith('www.') || (trimmed.includes('.') && trimmed.includes('/'))
  if (looksLikeBareDomain) {
    return { kind: 'url', value: 'https://' + trimmed }
  }

  return { kind: 'invalid' }
}
